import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 发送验证码
export function nanhangSendCaptcha(data) {
  return request({
    url: `${apiConfig.ZY}/platOrderH5/sendCaptcha`,
    method: 'post',
    hideErrorToast: true,
    data
  })
}
// 登录
export function nanhangLogin(data) {
  return request({
    url: `${apiConfig.ZY}/platOrderH5/login`,
    method: 'post',
    data
  })
}
// 分页查询订单
export function nanhangOrderPage(data) {
  return request({
    url: `${apiConfig.ZY}/platOrderH5/order/pages`,
    method: 'post',
    token: sessionStorage.getItem('nanhangToken'),
    data
  })
}
// 重发短信
export function nanhangResendMessage(orderId) {
  return request({
    url: `${apiConfig.ZY}/platOrderH5/order/resendMessage/${orderId}`,
    method: 'post',
    token: sessionStorage.getItem('nanhangToken')
  })
}
